import moment from 'moment';
export const formatAppointmentTime = (time, duration) => {
    const date = moment(time);
    return `${date.format('dddd, MMM D')} ⋅ ${date.format('h:mm')} - ${date
        .clone()
        .add(duration, 'minutes')
        .format('h:mm A')}`;
};
//# sourceMappingURL=time.js.map